import { schema } from "normalizr";

const BrandSchema = new schema.Entity("brands");
const BrandArraySchema = new schema.Array(BrandSchema);

export { BrandSchema, BrandArraySchema };